import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "modal fade bg-secondary",
  id: "searchingForCharities",
  tabindex: "-1",
  "data-bs-keyboard": "false",
  "aria-hidden": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-fullscreen text-white" }
const _hoisted_3 = { class: "modal-content container-fluid bg-transparent d-flex flex-column justify-content-center align-items-center" }
const _hoisted_4 = ["width", "height"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", { d: "M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" }, null, -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row fw-medium mt-0 mt-md-3 fs-5" }, [
  /*#__PURE__*/_createElementVNode("em", { class: "bi bi-stopwatch" }),
  /*#__PURE__*/_createElementVNode("p", { class: "ms-2 mb-0" }, "Please wait.")
], -1)
const _hoisted_9 = { class: "d-flex flex-column flex-md-row gap-3 mt-4" }
const _hoisted_10 = {
  key: 0,
  type: "button",
  class: "btn btn-white p-3 rounded-0",
  "data-bs-toggle": "modal",
  "data-bs-target": "#donationQueue"
}
const _hoisted_11 = {
  key: 1,
  type: "button",
  class: "btn btn-white p-3 rounded-0",
  "data-bs-dismiss": "modal"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline-white p-3 rounded-0",
  "data-bs-dismiss": "modal"
}, " Cancel Order ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreedingRhombusSpinner = _resolveComponent("BreedingRhombusSpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["align-self-center mb-4", {
            'pb-4': _ctx.foundQueuers === false,
            'mb-5': _ctx.windowWidth > 768 && _ctx.foundQueuers === false,
          }])
        }, [
          (_ctx.foundQueuers)
            ? (_openBlock(), _createElementBlock("svg", {
                key: 0,
                xmlns: "http://www.w3.org/2000/svg",
                width: _ctx.windowWidth > 768 ? 250 : 150,
                height: _ctx.windowWidth > 768 ? 250 : 150,
                fill: "currentColor",
                class: "bi bi-check-circle",
                viewBox: "0 0 16 16"
              }, _hoisted_7, 8, _hoisted_4))
            : (_openBlock(), _createBlock(_component_BreedingRhombusSpinner, {
                key: 1,
                "animation-duration": 2000,
                size: _ctx.windowWidth > 768 ? 200 : 125,
                color: "#ffffff"
              }, null, 8, ["size"]))
        ], 2),
        _createElementVNode("p", {
          class: _normalizeClass(["text-center fw-semibold mb-2", _ctx.windowWidth > 768 ? 'h2' : 'h3'])
        }, _toDisplayString(_ctx.foundQueuers ? "Found Receivers" : "Searching..."), 3),
        _createElementVNode("p", {
          class: _normalizeClass(["fw-normal", _ctx.windowWidth > 768 ? 'h6' : 'fs-6'])
        }, _toDisplayString(_ctx.foundQueuers
              ? "You may proceed to the donation queue now."
              : "Looking for receivers."), 3),
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          (_ctx.foundQueuers)
            ? (_openBlock(), _createElementBlock("button", _hoisted_10, " View Queue "))
            : (_openBlock(), _createElementBlock("button", _hoisted_11, " Go back ")),
          _hoisted_12
        ])
      ])
    ])
  ]))
}